import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../reducers'
import { Clear as ClearIcon } from '@mui/icons-material'
import { useStyles } from './SlidesStyles'
import { saveReportData, setPDFBytes } from '../../actions'
import ReportPreview from '../CaseDiagnosis/ReportGenerator/ReportPreview'
export default function ReleaseAmendmentReport({
  isReleaseAmendmentReportOpen,
  handleReleaseAmendmentReportClose,
  trfBarcode,
  pdfUrl,
  setPdfUrl,
}) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const getCPTCodes = useSelector((state: RootState) => state.getCPTCodesData)
  const [cptCodes, setCPTCodes] = useState([] as any)
  const [isReportLoaded, setReportLoaded] = useState(false)
  const { userLogin, name } = useSelector((state: RootState) => state.userLogin)
  const pdfUrlData = useSelector((state: RootState) => state.getPDFBytes)
  const draftData = useSelector((state: RootState) => state.setDraftReportData)
  const { workflowId, procedureCodeId } = useSelector((state: RootState) => state.getCaseData)
  const [pdfFlag, setPdfFlag] = useState(true)
  const getButtonClassName = () =>
    isReportLoaded ? `${classes.buttonMargin} ${classes.saveButton}` : `${classes.disableBtn}`

  useEffect(() => {
    if (pdfFlag && pdfUrlData && pdfUrlData.payload && pdfUrlData.payload.length > 0) {
      setPdfUrl(pdfUrlData.payload + '#zoom=100&')
      setPdfFlag(false)
    }
  }, [pdfUrlData, pdfFlag])

  useEffect(() => {
    if (pdfUrl) {
      setReportLoaded(true)
    } else {
      setReportLoaded(false)
    }
  }, [pdfUrl])

  const handleUploadReport = async () => {
    await dispatch(
      saveReportData({
        trfBarcode: trfBarcode,
        cptCodes: cptCodes,
        saveDraftJSON: draftData,
        reason: getReason(),
        diagnosisLP: { name: name, email: userLogin },
        consultLP: draftData.consultedPats && draftData.consultedPats.length > 0 ? draftData.consultedPats : [],
        calloutDecision: draftData.calloutDecision,
        procedureCode: procedureCodeId,
      }),
    )
  }

  const getReason = () => {
    switch (workflowId) {
      case 'CORRECT_ASSIGNED_READY':
        return 'corrected'
      case 'CORRECT_ASSIGNED_INPROGRESS':
        return 'corrected'
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_INPROGRESS':
        return 'publish'
      case 'PRIMARY_DIAGNOSIS_ASSIGNED_READY':
        return 'publish'
      case 'AMEND_INITIATED':
        return 'amended'
      case 'AMEND_RESULTED_RESULT_RELEASED':
        return 'amended'
    }
  }

  const handleCancel = async () => {
    setCPTCodes(getCPTCodes.payload)
    setPdfUrl('')
    await dispatch(setPDFBytes({ pdfUrl: '' }))
    handleReleaseAmendmentReportClose()
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="md"
        open={isReleaseAmendmentReportOpen}
        onClose={handleCancel}
        classes={{ paper: classes.amendDialogHeight }}
      >
        <DialogTitle className={classes.dialogTitle}>Release Amended Report</DialogTitle>
        <Divider />
        <DialogContent>
          <div style={{ height: '675px' }} className={classes.reportFullPreview}>
            <ReportPreview
              trfBarcode={trfBarcode}
              location={null}
              pdfUrl={pdfUrl}
              setPdfUrl={setPdfUrl}
              isRelease={true}
            />
          </div>
        </DialogContent>
        <DialogActions className={classes.buttonActions}>
          <Button onClick={handleUploadReport} className={getButtonClassName()}>
            Upload Report
          </Button>
          <Button
            className={`${classes.buttonMargin}`}
            variant="outlined"
            endIcon={<ClearIcon />}
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
